export default __webpack_public_path__ + "static/media/end_of_call.e084d52f.mp3";